<template>
    <base-layout>
        <template slot="sidebar">
            <div class="sidebar-content">
                <img src="../../assets/img/logo.png" class="logo" alt="logo"/><br/>

                <div class="side-menu">
                    <b class="heading">Workspace</b>

                    <router-link :to="{name: 'spaces'}" class="menu-item">
                        <i class="icon fas fa-briefcase"></i> Spaces
                    </router-link>

                    <router-link :to="{name: 'teams'}" class="menu-item">
                        <i class="icon fas fa-users"></i> Teams
                    </router-link>
                </div>

                <div v-if="user.is_staff" class="side-menu">
                    <b class="heading">Admin panel</b>

                    <router-link :to="{name: 'admin_dashboard'}" class="menu-item">
                        <i class="icon fas fa-tachometer-alt"></i> Dashboard
                    </router-link>
                </div>
            </div>
        </template>

        <div class="column scroll" :class="content_class">
            <slot></slot>
        </div>
    </base-layout>
</template>

<script>
import { mapState } from 'vuex';
import BaseLayout from './BaseLayout.vue';

export default {
    name: 'AppLayout',
    props: ['content_class'],
    components: { BaseLayout },
    inject: ['$validator'],
    computed: mapState('user', ['user']),
};
</script>

<style scoped>
    .logo {
        display: block;
        margin-left: auto;
        margin-right: auto;
        width: 85%;
        margin-bottom: 2rem;
    }
</style>
